document.addEventListener('DOMContentLoaded', (event) => {

class BannerVideoSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const _this = $(this);

    const slider =   _this.find('.header-banner-slider');

    if(slider.length) {
    const slider_speed = slider.attr('data-slider_speed') * 1;
    const autoplay_slider = slider.attr('data-autoplay_slider') == "true" ? true :false;

      const syncHiddenSlideFocus = function() {
        slider.find('.slick-slide').attr('tabindex', '-1');
        slider.find('.slick-slide[aria-hidden="true"]').find('a, button, input, select, textarea').attr('tabindex', '-1');
        slider.find('.slick-slide[aria-hidden="false"]').find('a, button, input, select, textarea').removeAttr('tabindex');
      };
    
      if(slider.find('.header-content-wrap').length > 1) {
       slider.on('init reInit afterChange setPosition', function () {
          syncHiddenSlideFocus();
       });
       slider.on('beforeChange', function (event, slick, currentSlide) {
           const currentSlideEl = slick && slick.$slides ? slick.$slides.get(currentSlide) : null;
           const activeEl = document.activeElement;

           if (currentSlideEl && activeEl && currentSlideEl.contains(activeEl)) {
             const fallbackFocusEl = slider.find('.slick-button-next, .slick-button-prev').get(0) || slider.get(0);
             if (fallbackFocusEl && typeof fallbackFocusEl.focus === 'function') {
               fallbackFocusEl.focus();
             } else if (activeEl && typeof activeEl.blur === 'function') {
               activeEl.blur();
             }
           }
       });
       slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
           const animationParentEl = slider.closest('.header-banner');
         if(animationParentEl.length) {
           animationParentEl.addClass('completed_animation');
         
         }
      });
       slider.slick({
          infinite: true,
         // Autoplay starts after window load so slides don't rotate mid-load (later lazy slides were becoming the LCP)
         autoplay: false,
         accessibility: false,
      autoplaySpeed: slider_speed,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: '<button type="button" class="slick-button-next product-articles-slider-next" aria-label="Next">' + window.assets.icon_right + '</button>',
        prevArrow: '<button type="button" class="slick-button-prev product-articles-slider-prev" aria-label="Previous">' + window.assets.icon_left + '</button>'
      });

      if (autoplay_slider && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const startAutoplay = () => slider.slick('slickPlay');
        if (document.readyState === 'complete') {
          startAutoplay();
        } else {
          window.addEventListener('load', startAutoplay, { once: true });
        }
      }
      }
    }


      
//     function TotalLength(el){
//       var path = document.querySelectorAll(el);
//       if($(el).length > 0){
//         for (let elem of path) {
//           if(elem.getAttribute("stroke-dasharray")){
//             var len = Math.round(elem.getTotalLength() );
//             elem.setAttribute("stroke-dasharray", len);
//             elem.setAttribute("stroke-dashoffset", len);
//             elem.classList.add('draw');
//           }
//         }
//       }
//     };

//  var header_banner = _this.find('.header-banner.with-animation');
//   if(header_banner.length){
//     header_banner.find('.z-top__header').css('opacity','1');

//     setTimeout(function() {
//       header_banner.find('.z-top__text').css('opacity','1');
//       header_banner.find('.header-content-icons-block svg').css('opacity','1');
//       header_banner.find('.header-content-icons-block img').css('opacity','1');
//       header_banner.find('#logo_actuators_landing').css('opacity','1');
//       TotalLength('#actuator-icon-collection path');
//       TotalLength('#actuator-icon-collection #Oval');
//       TotalLength('#actuator-icon-collection #Path');
//     }, 1000);
//     setTimeout(function() {
//       header_banner.find('.btn').css('opacity','1');
//       header_banner.find('.swiper-container').css('opacity','1');
//       header_banner.find('.brands-slide').css('opacity','1');
//       TotalLength('#actuator-icon path');
//       TotalLength('#actuator-icon #Oval');
//       TotalLength('#product_icon #Path');
//       TotalLength('#product_icon #Oval');
//       header_banner.find('.header-content-icons-title').css('opacity','1');
//       header_banner.find('.header-svg circle').css('opacity','1');

//     }, 2000);
//     setTimeout(function() {
//       header_banner.find('#actuator-icon .path-fill').addClass('full');
//       header_banner.find('#product_icon .path-fill').addClass('full');
//       header_banner.find('#product_icon .path-fill-dark').addClass('full');
//     }, 2600);
//   }
    
  }

}
customElements.define('image-animation-banner', BannerVideoSection);

});
